import React from "react";
import { Table, App, Select, Tag, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import InputNumberField from "../../../../../components/Input/InputNumber";
import {
  updateOrderRow,
  calculateTotals,
  setFooterValues,
  setPayServiceCart,
  setFormField,
} from "../purchaseReturnSlice";
import SharedFooter from "../../../../../components/DataTableFooter/SharedFooter";
import { fetchCurrentStock } from "../../../../Sales/salesThunks";
import Big from "big.js";
import { Input } from "antd";
import { accessChecker } from "../../../../../lib/functions";

const PurchaseReturnTable = ({ authInfo, onUpdateServices }) => {
  const dispatch = useDispatch();
  const { modal } = App.useApp();
  const footerValues = useSelector((s) => s.purchaseReturn.footerValues);
  const itemCart = useSelector((s) => s.purchaseReturn.itemCart);
  const taxMode = useSelector((s) => s.purchaseReturn.taxMode);
  const isTatmeen = useSelector((s) => s.purchaseReturn.isTatmeen);

  const isTatmeenEnabled =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");

  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const taxLabel = isIndia ? "GST" : "VAT";
  const gstEnabled = authInfo?.gst_enabled === "yes";
  const showTax = !isIndia || gstEnabled;

  const handleUpdate = (rowKey, field, value) => {
    dispatch(updateOrderRow({ rowKey, updates: { [field]: value } }));
    dispatch(calculateTotals({ authInfo }));
  };

  const handleFooterChange = (value, field) => {
    let updatedFooter = { ...footerValues };

    if (field === "payCart") {
      const newPaidAmount = value
        .filter((item) => item.acc_type_id !== "cheque") // 👈 exclude cheques
        .reduce((sum, item) => sum.plus(item.tran_amount || 0), Big(0))
        .toString();

      updatedFooter = {
        ...updatedFooter,
        paidAmount: newPaidAmount.toString(),
        dueAmount: Big(updatedFooter.grandTotal || 0)
          .minus(newPaidAmount)
          .toString(),
      };
      // update redux payment cart
      dispatch(setFormField({ field: "payCart", value }));
    }

    if (field === "paidAmount") {
      updatedFooter.paidAmount = Big(value || 0).toString();
      updatedFooter.dueAmount = Big(updatedFooter.grandTotal || 0)
        .minus(updatedFooter.paidAmount)
        .toString();
    } else {
      updatedFooter[field] = value;
    }

    dispatch(setFooterValues(updatedFooter));
    dispatch(calculateTotals({ authInfo }));
  };

  const columns = [
    {
      title: "Item",
      dataIndex: "product",
      // `product` is the plain item name used elsewhere for the return
      // payload -- display_text (set in purchaseReturnThunk.js from the
      // backend's item-with-code/barcode query) is the fuller label.
      render: (_, record) => record.display_text || record.product,
    },
    {
      title: "Invoice Qty",
      dataIndex: "invoice_qty",
    },

    {
      title: "Returned",
      dataIndex: "returned_qty",
    },
    {
      title: "Available Qty",
      dataIndex: "available_qty",
      render: (_, record) => record.available_qty,
    },
    ...(isTatmeenEnabled && hasTatmeenEntryAccess ? [
      {
        title: "Tatmeen",
        dataIndex: "is_tatmeen_required",
        width: 100,
        render: (_, record) => (
          <Checkbox
            checked={record.is_tatmeen_required || false}
            disabled={true}
            onChange={(e) => {
              const checked = e.target.checked;
              handleUpdate(record.key, "is_tatmeen_required", checked);

              // If unchecked, clear SSCC and serials
              if (!checked) {
                handleUpdate(record.key, "child_sscc_code", "");
                handleUpdate(record.key, "selectedSerials", []);
              } else {
                // If checked, initialize serials based on return quantity
                const returnQty = Number(record.return_qty || 0);
                // Don't auto-select serials, user must select manually
              }
            }}
          >
            Required
          </Checkbox>
        ),
      },
    ] : []),
    ...(isTatmeenEnabled && hasTatmeenEntryAccess ? [
      {
        title: "Mode",
        render: (_, record) => (
          <Tag
            color={record.serial_mode === "batch" ? "blue" : "green"}
          >
            {record.serial_mode === "batch" ? "Batch" : "Unit"}
          </Tag>
        )
      },
      {
        title: "Child SSCC Code",
        dataIndex: "child_sscc_code",
        width: 200,
        render: (_, record) => (
          <Input
            value={record.child_sscc_code || ""}
            placeholder={record.is_tatmeen_required ? "Required*" : "Optional"}
            disabled={!record.is_tatmeen_required || !isTatmeenEnabled}
            onChange={(e) => {
              handleUpdate(record.key, "child_sscc_code", e.target.value);
            }}
            style={{
              borderColor: record.is_tatmeen_required && !record.child_sscc_code && Number(record.return_qty) > 0
                ? '#ff4d4f'
                : undefined
            }}
          />
        ),
      },
    ] : []),

    // {
    //   title: "Return Qty",
    //   dataIndex: "return_qty",
    //   width: 150,
    //   render: (_, record) => (
    //     <InputNumberField
    //       min={0}

    //       max={record.available_qty}

    //       precision={1}

    //       step={0.5}

    //       value={record.return_qty}

    //       placeholder="0"

    //       onChange={(v) => {
    //         if (
    //           authInfo?.is_tatmeen_enabled === "yes" &&
    //           record.serial_mode === "batch"
    //         ) {
    //           const invoiceQty = Number(record.invoice_qty || 0);

    //           // Only allow 0 or full invoice quantity
    //           if (Number(v) !== 0 && Number(v) !== invoiceQty) {
    //             modal.warning({
    //               title: "Invalid Return Quantity",
    //               content: `For Batch Serial Mode, Return Qty must be either 0 or ${invoiceQty}.`,
    //             });
    //             return;
    //           }
    //         }

    //         dispatch(
    //           fetchCurrentStock({
    //             itemId: record.item_id,
    //             warehouseId: 0,
    //           })
    //         ).then((res) => {
    //           if (!res?.payload) return;

    //           const currentQty = res.payload.current_qty;
    //           const isMinusSale = authInfo.is_minus_stock_sale;

    //           if (v > currentQty && isMinusSale === "no") {
    //             modal.warning({
    //               title: `Insufficient quantity of ${record.product}`,
    //             });
    //             return;
    //           }

    //           handleUpdate(record.key, "return_qty", v);
    //         });
    //       }}
    //     />
    //     // <InputNumberField
    //     //   min={0}
    //     //   precision={1}
    //     //   step={0.5}
    //     //   max={record.available_qty}
    //     //   value={record.return_qty}
    //     //   placeholder="0"
    //     //   onClick={() => {
    //     //     if (record.return_qty !== null) {
    //     //       handleUpdate(record.key, "return_qty", null);
    //     //     }
    //     //   }}
    //     //   // onChange={(v) => {
    //     //   //   handleUpdate(record.key, "return_qty", v);

    //     //   //   if (
    //     //   //     record.otherServiceTransactions &&
    //     //   //     Array.isArray(record.otherServiceTransactions)
    //     //   //   ) {
    //     //   //     const updatedServices = record.otherServiceTransactions.map(
    //     //   //       (service) => {
    //     //   //         const perUnit = Number(service.service_amount_per_unit);
    //     //   //         const total = perUnit * v;

    //     //   //         return {
    //     //   //           ...service,
    //     //   //           updated_service_total: parseFloat(total.toFixed(2)), // store calculated total
    //     //   //         };
    //     //   //       }
    //     //   //     );
    //     //   //     onUpdateServices(updatedServices, record.key);
    //     //   //   }
    //     //   // }}

    //     //   onChange={(v) => {
    //     //     dispatch(
    //     //       fetchCurrentStock({
    //     //         itemId: record.item_id,
    //     //         warehouseId: 0,
    //     //       })
    //     //     ).then((res) => {
    //     //       if (!res?.payload) return;

    //     //       const currentQty = res.payload.current_qty;

    //     //       const isMinusSale = authInfo.is_minus_stock_sale;

    //     //       if (v > currentQty && isMinusSale === "no") {
    //     //         modal.warning({
    //     //           title: `Insufficient quantity of ${record?.product} available`,
    //     //           content: (
    //     //             <>
    //     //               <p>
    //     //                 Available Quantity Is:{" "}
    //     //                 <strong style={{ color: "red" }}>{currentQty}</strong>
    //     //               </p>
    //     //             </>
    //     //           ),
    //     //         });
    //     //         return;
    //     //       }

    //     //       handleUpdate(record.key, "return_qty", v);

    //     //       if (
    //     //         record.otherServiceTransactions &&
    //     //         Array.isArray(record.otherServiceTransactions)
    //     //       ) {
    //     //         const updatedServices = record.otherServiceTransactions.map(
    //     //           (service) => {
    //     //             const perUnit = Big(service.service_amount_per_unit || 0);
    //     //             const total = perUnit.times(v || 0);

    //     //             return {
    //     //               ...service,
    //     //               updated_service_total: total.toString(),
    //     //             };
    //     //           }
    //     //         );

    //     //         onUpdateServices(updatedServices, record.key);
    //     //       }
    //     //     });
    //     //   }}
    //     //   style={{ maxWidth: "100px" }}
    //     //   data-testid={`return-qty-val`}
    //     // />


    //   ),
    // },

    {
      title: "Return Qty",
      dataIndex: "return_qty",
      width: 150,
      render: (_, record) => (
        <InputNumberField
          min={0}
          max={record.available_qty}
          precision={1}
          step={0.5}
          value={record.return_qty}
          placeholder="0"
          data-testid={`return-qty-val`}
          onChange={(v) => {
            // ✅ Only update the value without validation
            handleUpdate(record.key, "return_qty", v);

            // ✅ Check stock separately
            if (record.is_tatmeen_required) {
              handleUpdate(record.key, "selectedSerials", []);
            }

            dispatch(
              fetchCurrentStock({
                itemId: record.item_id,
                warehouseId: 0,
              })
            ).then((res) => {
              if (!res?.payload) return;
              const currentQty = res.payload.current_qty;
              const isMinusSale = authInfo.is_minus_stock_sale;
              if (v > currentQty && isMinusSale === "no") {
                modal.warning({
                  title: `Insufficient quantity of ${record.product}`,
                });
                // Revert to previous value or 0
                handleUpdate(record.key, "return_qty", 0);
                return;
              }
            });

          }}
          onBlur={() => {
            // ✅ Validate batch mode on blur (when user finishes typing)
            if (
              authInfo?.is_tatmeen_enabled === "yes" &&
              record.serial_mode === "batch" && record.is_tatmeen_required
            ) {
              const currentQty = Number(record.return_qty || 0);
              const invoiceQty = Number(record.invoice_qty || 0);

              // Only validate if value is not 0 and not full quantity
              if (currentQty !== 0 && currentQty !== invoiceQty) {
                modal.warning({
                  title: "Invalid Return Quantity",
                  content: `For Batch Serial Mode, Return Qty must be either 0 or ${invoiceQty}.`,
                });
                // ✅ Reset to 0 or invoiceQty (whichever is closer)
                if (currentQty > invoiceQty / 2) {
                  handleUpdate(record.key, "return_qty", invoiceQty);
                } else {
                  handleUpdate(record.key, "return_qty", 0);
                }
              }
            }
          }}
        />
      ),
    },
    {
      title: "Rate",
      dataIndex: "item_return_unit_price",
      render: (_, record) => Big(record.item_return_rate || 0).toFixed(2),
    },
    ...(showTax ? [
      {
        title: `${taxLabel} `,
        dataIndex: "tax_per",
        render: (_, record) => Number(record.tax_per || 0).toFixed(2),
      },
    ] : []),
    ...(isTatmeenEnabled && hasTatmeenEntryAccess ? [
      {
        title: "Serial Numbers",
        dataIndex: "selectedSerials",
        width: 300,

        render: (_, record) => {

          if (!record.is_tatmeen_required) {
            return <Tag color="default">Not Required</Tag>;
          }
          return (
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Serial Numbers"
              value={record.selectedSerials || []}
              onChange={(value) => {
                handleUpdate(record.key, "selectedSerials", value);
              }}
              options={(record.availableSerials || []).map(serial => ({
                label: serial,
                value: serial,
              }))}
              disabled={!record.is_tatmeen_required}
            />
          );

        }
      },
    ] : []),


    {
      title: "Line Total",
      render: (_, r) => {
        const qty = Big(r.return_qty || 0);
        const rate = Big(r.item_return_rate || 0);
        const taxPct = showTax ? new Big(r.tax_per || 0) : new Big(0);
        const taxAmt = qty.times(rate).times(taxPct).div(100);
        const line = (qty.times(rate)).plus(taxAmt);

        // if (taxMode === "on_item") {
        //   const discountAmt = (Number(r.discount) / 100) * line || 0;
        //   line -= discountAmt;
        //   const taxAmt = (line * Number(r.tax_per)) / 100 || 0;
        //   line += taxAmt;
        // }
        return line.toFixed(2);
      },
    },
  ];

  return (
    <div style={{ width: "100%", maxWidth: "1300px" }}>
      <Table
        dataSource={itemCart}
        columns={columns}
        pagination={false}
        rowKey="key"
        scroll={{ x: "min-content" }}
        footer={() => (
          <SharedFooter
            footerValues={footerValues}
            dataSource={itemCart}
            onFooterChange={handleFooterChange}
            pageType="purchaseReturn"
            taxMode={taxMode}
          />
        )}
      />
    </div>
  );
};

export default PurchaseReturnTable;
